import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BlogData from "../../../data/blog/BlogData.json";
import { useSelector } from "react-redux";
import { media_url, useBlog } from "../../../hooks/useBlog";
import { slugify } from "../../../utils";

const allBlogData = BlogData;

const WidgetPost = () => {
  const { posts, recentPosts } = useSelector((state) => state.blog);
  const { getPost } = useBlog();

  
  
  
  

  return (
    <div className="post-list-wrap">
      {recentPosts?.map((data, index) => (
        <div className="single-post" key={index}>
          <div className="post-thumbnail">
            <Link to={process.env.PUBLIC_URL + `/post/${slugify(data.title)}?id=${data.id}`}>
              <img src={media_url(data.image)} alt="Blog" />
            </Link>
          </div>
          <div className="post-content">
            <h6 className="title">
              <Link to={process.env.PUBLIC_URL + `/post/${slugify(data.title)}?id=${data.id}`}>
                {data.title}
              </Link>
            </h6>
            <ul className="blog-meta list-unstyled">
              <li>
                {new Date(data.created).toLocaleDateString("es-ES", {
                  weekday: "long",
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })}
              </li>
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WidgetPost;
